import { useUserInfo } from '@/context/user-info';
import { cn } from '@/lib/utils';
import { aboutApp, howItWorks } from '@/misc/images';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export const HomeSectionsButtons = ({ halfScreen }: { halfScreen?: boolean }) => {
  const { userLanguage } = useUserInfo();
  const { t } = useTranslation();

  const links = [
    {
      id: 1,
      title: t('translation:home.button.how_it_works.title'),
      subtitle: t('translation:home.button.how_it_works.subtitle'),
      image: howItWorks,
      path: `/${userLanguage}/how-it-works`,
      ariaLabel: t('translation:accessibility.button.go_how_it_works'),
    },
    {
      id: 2,
      title: t('translation:home.button.about.title'),
      subtitle: t('translation:home.button.about.subtitle'),
      image: aboutApp,
      path: `/${userLanguage}/about-app`,
      ariaLabel: t('translation:accessibility.button.go_about_app'),
    },
  ];

  return (
    <main
      className={cn({
        'hidden absolute bottom-8 md:flex items-center gap-4 justify-end': !halfScreen,
        'flex flex-col gap-4 px-4 md:hidden': halfScreen,
      })}
    >
      {links.map((item) => (
        <section key={item.id}>
          <Link
            to={item.path}
            className="group h-28 md:h-20 w-full md:w-72 flex items-center gap-2.5 bg-bg-primary rounded-2xl md:rounded-full py-3 px-4 transition-all duration-200 outline outline-0 outline-outline-primary hover:md:outline hover:md:outline-4 hover:md:outline-outline-primary"
            aria-label={item.ariaLabel}
          >
            <img
              src={item.image}
              alt=""
              className="h-20 md:h-14 transition-transform duration-200 group-hover:scale-105"
              aria-hidden="true"
            />
            <div className="group pr-1">
              <p className="text-fg-brand font-bold text-base">{item.title}</p>
              <p className="text-fg-primary text-sm leading-tight">{item.subtitle}</p>
            </div>
          </Link>
        </section>
      ))}
    </main>
  );
};
